import { Row as BaseRow, RowProps as BaseRowProps } from 'antd'

export interface RowProps extends BaseRowProps {}

export const Row = (props: RowProps): JSX.Element => (
  <>
    <BaseRow {...props} />
  </>
)
